import React from 'react';
import Wrapper from './style';

const Index = ({ record }) => {
  const { extended_entities: extendedEntities, entities } = record;
  const extendedMedia = extendedEntities?.media || [];
  if (extendedMedia?.length === 0) {
    return null;
  }
  const sampleExtendedMedia = extendedMedia[0];
  const isPhotosMedia = sampleExtendedMedia?.type === 'photo';
  const entitiesMedia = entities?.media[0];
  const videoInfo = sampleExtendedMedia?.video_info;
  const videoDuration = videoInfo?.duration_millis;
  const minutes = Math.floor(videoDuration / 60000);
  const seconds = ((videoDuration % 60000) / 1000).toFixed(0);
  const time = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  return (
    <Wrapper>
      <img src={entitiesMedia?.media_url_https} alt="thumb" />
      {!isPhotosMedia && (
        <div className="component_creative_column_image_time font-caption">
          {time}
        </div>
      )}
    </Wrapper>
  );
};

export default Index;
